import { Icon } from '@iconify/react';

export const ICON_MAP = {
  search: <Icon icon="mdi:magnify" />,
  clear: <Icon icon="mdi:close-circle-outline" />,
  export: <Icon icon="ph:export" />,
  columns: <Icon icon="mdi:view-column-outline" />,
  fullscreen: <Icon icon="mdi:fullscreen" />,
  exitFullscreen: <Icon icon="mdi:fullscreen-exit" />,
  normal: <Icon icon="ph:magnifying-glass-plus" />,
  compact: <Icon icon="ph:magnifying-glass-minus" />,
  next: <Icon icon="ic:baseline-navigate-next" />,
  previous: <Icon icon="ic:baseline-navigate-before" />,
  loading:<Icon icon="line-md:downloading-loop" style={{color: '#2e00f1'}} />,
  refresh:<Icon icon="mdi:refresh" />,
};
